// extracted by mini-css-extract-plugin
export default {"pageLayout":"PageLayout_pageLayout__+Ax1h","pageBody":"PageLayout_pageBody__nMnZV","pageTitle":"PageLayout_pageTitle__egZTH","pageContent":"PageLayout_pageContent__EUvBq"};